import { GROUP_HEADER_HEIGHT } from "../settings.ts";
import { useGenomeViewerStore } from "../store/store.ts";

export function getTrackGroupIndexByY(y: number): number | undefined {
  let index = 0;
  let offsetY = 0;
  const state = useGenomeViewerStore.getState();

  for (const [_, trackGroup] of [...state.trackGroups.entries()].filter(([_, group]) => group.graphics.isVisible)) {
    const tracks = trackGroup.trackIds
      .map((trackId) => state.tracks.get(trackId))
      .filter((track): track is NonNullable<typeof track> => !!track?.isVisible);

    const height = [...tracks.values()].reduce((acc, track) => acc + track.height, GROUP_HEADER_HEIGHT);

    if (y >= offsetY && y < offsetY + height) {
      return index;
    }
    offsetY += height;
    index++;
  }
  return;
}
